import detail from './detail/routes';
import list from './list/routes';

export default [list, detail];
